function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "mastercard-color");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Cards",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Payment-Methods",
  transform: "translate(-176.000000, -192.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "mastercard-color",
  transform: "translate(176.000000, 192.000000)"
}, React.createElement("rect", {
  id: "card_bg",
  fill: "#F2F0EC",
  x: 0,
  y: 0,
  width: 24,
  height: 16,
  rx: 2
}), React.createElement("g", {
  id: "mastercard",
  transform: "translate(2.000000, 1.000000)"
}, React.createElement("g", {
  id: "Group",
  opacity: 0,
  fill: "#FFFFFF"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0.32,
  y: 0.6,
  width: 19.35,
  height: 12.8
})), React.createElement("rect", {
  id: "Rectangle",
  fill: "#F26122",
  x: 7.45,
  y: 2.83,
  width: 5.11,
  height: 8.34
}), React.createElement("path", {
  d: "M8,7 C7.99454005,5.37743642 8.73123614,3.84142506 10,2.83 C7.82640832,1.1248754 4.70761511,1.37532411 2.83397586,3.40545381 C0.960336605,5.43558352 0.960336605,8.56441648 2.83397586,10.5945462 C4.70761511,12.6246759 7.82640832,12.8751246 10,11.17 C8.72885353,10.1604741 7.99156758,8.62323285 8,7 Z",
  id: "Path",
  fill: "#EA1D25"
}), React.createElement("path", {
  d: "M18.07,10.29 L18.07,10.12 L18.15,10.12 L18.15,10.12 L18,10.12 L18,10.12 L18,10.12 L18,10.29 L18.07,10.29 Z M18.41,10.29 L18.41,10.08 L18.36,10.08 L18.3,10.23 L18.24,10.08 L18.18,10.08 L18.18,10.29 L18.18,10.29 L18.18,10.13 L18.24,10.26 L18.24,10.26 L18.3,10.13 L18.3,10.29 L18.41,10.29 Z",
  id: "Shape",
  fill: "#F69E1E"
}), React.createElement("path", {
  d: "M18.5800045,7 C18.5747799,9.0278811 17.4150224,10.8757224 15.5911357,11.7621568 C13.7672489,12.6485913 11.5977422,12.418819 10,11.17 C11.2772258,10.1630956 12.0225694,8.62639546 12.0225694,7 C12.0225694,5.37360454 11.2772258,3.83690437 10,2.83 C11.5957107,1.57278479 13.76964,1.338287 15.5967513,2.22628865 C17.4238626,3.11429031 18.582637,4.96852867 18.5800045,7 Z",
  id: "Path",
  fill: "#F69E1E"
})))));

var SvgMc = function SvgMc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mc.c7ec227a.svg";
export { ForwardRef as ReactComponent };